// extracted by mini-css-extract-plugin
export default {"root":"classes_root__hRfnp","info":"classes_info__uLNPj","buttons-container":"classes_buttons-container__tuVJp"};